import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import { PrimaryButton } from '@lib/common';
import { AssignmentType, ScoreVisibilityType } from '@module/assignment';
import styled from '@xstyled/styled-components';
import { Skeleton } from 'antd';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var StyledSpan = styled.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"])));
export var PublishScoreComponent = function PublishScoreComponent(_ref) {
  var assignment = _ref.assignment,
      attendeeList = _ref.attendeeList,
      isGetAssignmentByIdExecuting = _ref.isGetAssignmentByIdExecuting,
      isPublishScoreSuccess = _ref.isPublishScoreSuccess,
      onShowPublishScoreModal = _ref.onShowPublishScoreModal,
      translations = _ref.translations;

  var renderActionButton = function renderActionButton() {
    if (!assignment || isGetAssignmentByIdExecuting) {
      return /*#__PURE__*/_jsx(Skeleton.Button, {
        active: true
      });
    }

    if (!attendeeList) {
      return null;
    }

    var isExaminationAssignment = assignment.type.id === AssignmentType.Examination;
    var isAllAttendeeGraded = attendeeList.every(function (attendee) {
      return attendee.report.gradedPercentage === 100;
    });
    var examinationAssignment = assignment;

    if (assignment.isEnded() && isExaminationAssignment) {
      var isDisabled = examinationAssignment.scoreVisibilityType.value === ScoreVisibilityType.immediateViewAfterSubmit.value || examinationAssignment.hasPublished() || !isAllAttendeeGraded;
      return /*#__PURE__*/_jsx(StyledSpan, {
        children: /*#__PURE__*/_jsx(PrimaryButton, {
          size: "middle",
          block: true,
          onClick: function onClick() {
            return onShowPublishScoreModal(true);
          },
          disabled: isDisabled,
          children: translations.publishScoreButton
        })
      });
    }
  };

  return renderActionButton() || /*#__PURE__*/_jsx(_Fragment, {});
};